var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"duration":800,"name":"fade"}},[(_vm.show)?_c('small',{class:'text-' + _vm.type},[_vm._t("default",function(){return [_vm._v(" ")]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }